import React from 'react';
import { StyleSlider } from '../components/common';
import { TopicStyles } from '../mixins/mixins';

export const GreetingStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="grid grid-cols-2 lg:grid-cols-3 justify-items-center gap-4">
			<StyleSlider
				key={'greetings_size-range'}
				id={'greetings_size-range'}
				name={'Size'}
				initialValue={style.greetingStyle?.size}
				minValue={'30'}
				maxValue={'65'}
				step={'5'}
				handleChange={({ value }: { value: any }) => {
					setStyle({
						...style,
						greetingStyle: { ...style.greetingStyle, ['size']: value }
					});
				}}
			/>
		</div>
	);
};
